import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IClientLead } from "../../models/ClientLead";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { EmptyClientLead } from "./EmptyClientLead";
import { IModel } from "./ClientLead";
import { Search } from "../../shared/Search";
import { format } from "date-fns";
import { ILogin, IPermissionProps } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";


interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IClientLead>, loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [globalFilter, setGlobalFilter] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'lead_ID',
        sortOrder: -1
    });

    useEffect(() => {
        getTableDataCount();
        loadTableData();
    }, [globalFilter, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getTableDataCount = async () => {
        const response = await Fetch("Client_Lead/count", "GET", null, `filter=${globalFilter}`, props.toast);
        if (response) {
            const count: number = parseInt(await response.text(), 10);
            setTotalRecords(count);
        }
    }

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Client_Lead", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=${globalFilter}`, props.toast);
        if (response) {
            const data: Array<IClientLead> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyClientLead });
    };


    const openEdit = (rowDatauser: IClientLead) => {
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Manage ClientLeads</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Search setSearch={setGlobalFilter} />
            </span>
        </div>
    );

    const urlBodyTemplate = (rowData: IClientLead) => {
        return (
            rowData.url && <a target="_blank" href={rowData.url}>{rowData.url}</a>
        );
    };
    const createdOnBodyTemplate = (rowData: IClientLead) => {
        let date;
        if (rowData.createdOn) date = format(new Date(rowData.createdOn), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const actionBodyTemplate = (rowData: IClientLead) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />
            </div>
        );
    };

    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small"
                value={tableData.tableData} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={totalRecords} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                emptyMessage="No Users found."
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                <Column field="companyName" header="Company" sortable />
                <Column field="url" header="URL" body={urlBodyTemplate} />
                <Column field="location" header="Location" sortable />
                <Column field="noOfEmployee" header="No Of Employee" sortable />
                <Column field="user_Name" header="Sales Manager" sortable />
                {/* <Column field="createdOn" header="Created At" body={createdOnBodyTemplate} sortable /> */}
                <Column field="createdOn" header="Created At"  sortable  body={(rowData: any) => safeFormatDate( rowData.createdOn, "yyyy-MM-dd",  DateFormat )} />
                <Column body={actionBodyTemplate} />
            </DataTable>
        </>
    )
}
